// extracted by mini-css-extract-plugin
export default {"card":"Card_card__Y7-Nw","right":"Card_right__6P+iS","bottom":"Card_bottom__O8FtO","left":"Card_left__6e6rZ","top":"Card_top__N72Ia","icon":"Card_icon__zs7eK"};